import { persistedStore } from "@/lib/stores/persisted-store";
import { Unit, VALID_PRECISIONS } from "@/lib/measure";

interface State {
  unit: Unit;
  precision: Record<Unit, string>;
}

interface Actions {
  setUnit: (unit: Unit) => void;
  setPrecision: (unit: Unit, precision: string) => void;
}

const defaults: State = {
  unit: Unit.INCHES_FRACTIONAL,
  precision: {
    [Unit.INCHES_FRACTIONAL]: "1/16",
    [Unit.FEET_INCHES]: "1/16",
    [Unit.INCHES_DECIMAL]: "0.01",
    [Unit.MILLIMETERS]: "0.1",
  },
};

export const useUnitPreferencesStore = persistedStore<State & Actions>(
  (set) => ({
    ...defaults,
    setUnit: (unit) => set({ unit }),
    setPrecision: (unit, precision) => {
      if (!VALID_PRECISIONS[unit].has(precision)) {
        console.warn(`invalid precision ${precision} for unit ${unit}`);
        return;
      }
      set((s) => ({ precision: { ...s.precision, [unit]: precision } }));
    },
  }),
  {
    name: "unit-preferences",
    partialize: (s) => ({ unit: s.unit, precision: s.precision }),
  },
);

export function useUnit(): Unit {
  return useUnitPreferencesStore((s) => s.unit);
}

export function useCurrentPrecision(): string {
  return useUnitPreferencesStore((s) => s.precision[s.unit]);
}
